import store from "./index";
import {
  getEntries,
  getAssessmentData,
  getAssessmentQuestions,
  saveAssessment
} from "../api/assessments";

export default {
  namespaced: true,
  state: () => ({
    assessments: []
  }),
  mutations: {
    setAssessments(state, data) {
      state.assessments = data;
    },
    clearData(state) {
      state.assessments = [];
    }
  },
  getters: {
    getAssessment: state => id => {
      return state.assessments.find(assessment => assessment.id === id);
    },
    getAssessmentQuestions: state => id => {
      let assessment = state.assessments.find(
        assessment => assessment.id === id
      );
      return assessment ? assessment.questions : [];
    },
    getAssessmentOptions: state => id => {
      let assessment = state.assessments.find(
        assessment => assessment.id === id
      );
      return assessment ? assessment.options : [];
    },
    getAssessmentEntries: state => () => {
      return state.assessments;
    },
    getAssessmentEntry: state => id => {
      return state.assessments.find(assessment => assessment.id === id);
    }
  },
  actions: {
    async fetchEntries({ commit }, id) {
      try {
        let response = await getEntries(id);
        commit("setAssessments", response);
        return response;
      } catch (err) {
        console.error(err);
      }
    },

    async fetchEntryData({ commit }, id) {
      try {
        let response = await getAssessmentData(id);
        let assessment = this.getters["assessments/getAssessment"](id);

        if (!assessment) {
          commit("setAssessments", [response]);
        } else {
          Object.assign(assessment, response);
        }

        return response;
      } catch (err) {
        console.error(err);
      }
    },

    async fetchAssessmentQuestions({ commit }, id) {
      try {
        let response = await getAssessmentQuestions(id);
        let assessment = this.getters["assessments/getAssessment"](id);

        assessment.questions = response;

        console.log(assessment);

        if (!assessment) {
          commit("setAssessments", [response]);
        } else {
          Object.assign(assessment, response);
        }

        return response;
      } catch (err) {
        console.error(err);
      }
    },

    async saveAssessment({ commit }, { data }) {
      try {
        let response = await saveAssessment(data.id, data);
        let assessment = this.getters["assessments/getAssessment"](data.id);

        Object.assign(assessment, response);

        return response;
      } catch (err) {
        console.error(err);
      }
    }
  }
};
